import { makeStyles } from '@material-ui/core/styles';

import { RiLightbulbLine } from '@remixicon/react';

import { Text } from '@backstage/ui';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'var(--bui-space-2)',
    padding: 'var(--bui-space-2) 0',
    color: 'var(--bui-fg-secondary)',
  },
  icon: {
    marginTop: 2,
    flexShrink: 0,
  },
});

export const ThinkingMessage = ({ content }: { content: string }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <RiLightbulbLine size={16} className={classes.icon} />
      <Text variant="body-small" color="secondary">
        {content}
      </Text>
    </div>
  );
};
